import React, { FC, useEffect, useState } from 'react'
import { AEAField } from '@components/'
import { BasicDataBudgetPresenter } from '@presenters/screens/basic-data-budget.presenter';
import { IBasicDataBudget } from '@interfaces/screens/basic-data-budget.interface';
import { Container, Row, Col } from 'reactstrap';
import { Enums } from '@utils';

const BaseDataBudget: FC<any> =() => {
    const [exist,setProjectExist] = useState(false); 
    const [budgetType,setBudgetType] = useState(1); 
    const [readOnly ,setReadOnly] = useState(false);
    const [allowedEdit ,setAllowedEdit] = useState(false);
    const [numberReset ,setNumberReset] = useState(false);

    const view: IBasicDataBudget = {
        state: {
            exist: exist,
            budgetType: budgetType,
            readOnly: readOnly,
            allowedEdit: allowedEdit,
            numberReset: numberReset,
            setProjectExist: setProjectExist,
            setBudgetType: setBudgetType,
            setReadOnly: setReadOnly,
            setAllowedEdit: setAllowedEdit,
            setNumberReset: setNumberReset
        }
    }
    const presenter = new BasicDataBudgetPresenter(view);    
    
    useEffect(()=> presenter.switchView(),[] );
    useEffect(() => { presenter.initializeBudgetType() },
        [
            presenter.formMaster,
            presenter.projectNumber,
            presenter.currentBudget
        ]
    );
    const renderBudgetByProjectFields = () => {
        if (budgetType !== Enums.SystemParameters.BudgetTypeOn) {
            return (
                <>
                <Col>
                    <AEAField {...presenter.titleField }></AEAField> 
                </Col>
                <Col>
                    <AEAField {...presenter.projectNumberField}></AEAField>
                </Col> 
                <Col>
                    {
                        !view.state.exist ? 
                        <AEAField {...presenter.projectCodeTextField}></AEAField> : 
                        <AEAField {...presenter.projectCodeSelectField}></AEAField>
                    }                    
                </Col>
                <Col>                    
                    <AEAField {...presenter.interventionLineField}></AEAField>
                </Col> 
                </>
            );
        } else {
            return (<div></div>);
        }
    }
    // Start View
    if(presenter.initRender()){
        return (         
        <Container fluid={true}>          
            <Row> 
                {!view.state.allowedEdit && !view.state.readOnly ?                
                <Col xs="4" sm="4" md="3" lg="2" xl="2">
                    <AEAField {...presenter.existField}></AEAField>
                </Col> : <div></div>}
                <Col>
                    <AEAField {...presenter.budgetTypeField}></AEAField>
                </Col>
            </Row> 
            <Row md={2}>
                <Col>
                    <AEAField {...presenter.yearField}></AEAField>
                </Col>
                <Col>
                    <AEAField {...presenter.regionCountryField}></AEAField>
                </Col>  
                {renderBudgetByProjectFields()}
            </Row>  
        </Container>
        );
    } else {
        return <div></div>;
    }
}

export default BaseDataBudget;